import { get } from 'core-js/core/dict'
import { darken, lighten, getBrightness } from './utils'

export const baseColors = {
	white: '#ffffff',
	black0: '#000000',
	black1: '#1F1F1F',
	black2: '#424242',
	black3: '#888888',
	black4: '#CCCCCC',
	black5: '#F2F2F2'
}

function makeScale(c, n) {
	const scale = []

	const maxDarken = 0.5
	const maxLighten = 0.7

	const nDarken = 2
	const nLighten = n - 1 - nDarken
	const stepDarken = maxDarken / nDarken
	const stepLighten = maxLighten / nLighten

	for (let i = nDarken; i > 0; i--) {
		scale.push(darken(c, stepDarken * i))
	}
	scale.push(c)
	for (let i = 1; i <= nLighten; i++) {
		scale.push(lighten(c, stepLighten * i))
	}

	scale.reverse()

	return scale
}

const def = {
	// colors that might be needed in components
	white: baseColors.white,
	black0: baseColors.black0,
	black1: baseColors.black1,
	black2: baseColors.black2,
	black3: baseColors.black3,
	black4: baseColors.black4,
	black5: baseColors.black5,

	// new
	primary: '#FFCA87',
	secondary: '#E47039',
	tertiary: '#E3432D',

	// new for 04_line_construction_costs_countries
	pricelinechart_1: '#4200AE',
	pricelinechart_2: '#9997FF',
	pricelinechart_3: '#B3A0FF',
	pricelinechart_4: '#D599F9',

	// new for 03_map_building_premits

	noDataColor: '#C5C7CD',

	background: '#fff',

	gray: '#ADACB2',
	grayLight: '#C6C8CE',

	textBlack: '#2A2A2A',
	textSecondary: '#89868F',
	textTertiary: '#A9A6B0',

	scalePrimary1: '#FFDD71',
	scalePrimary2: '#FFCE50',
	scalePrimary3: '#F1AB27',
	scalePrimary4: '#D37908',
	scalePrimary5: '#B05A01',
	scalePrimary6: '#7F3601',

	scaleTertiary1: '#FFCAB4',
	scaleTertiary2: '#FFA59C',
	scaleTertiary3: '#F87A82',
	scaleTertiary4: '#CF4D82',
	scaleTertiary5: '#A5287A',
	scaleTertiary6: '#78096C'
}

let colors = { ...def }

function makeExtraColors() {
	colors.bg = colors.background

	colors.textThemedPrimary = darken(colors.primary, 0.4)

	colors.scalePrimary = [
		colors.scalePrimary1,
		colors.scalePrimary2,
		colors.scalePrimary3,
		colors.scalePrimary4,
		colors.scalePrimary5,
		colors.scalePrimary6
	]
	colors.scaleTertiary = [
		colors.scaleTertiary1,
		colors.scaleTertiary2,
		colors.scaleTertiary3,
		colors.scaleTertiary4,
		colors.scaleTertiary5,
		colors.scaleTertiary6
	]

	// colors.textColors = {}
	// ;[
	// 	...colors.scaleMain,
	// 	...colors.scaleLarge,
	// 	colors.gray,
	// 	colors.primary,
	// 	colors.secondary,
	// 	colors.tertiary,
	// 	colors.helper,
	// 	colors.add1,
	// 	colors.mapBerlinPublicInstitutions,
	// 	colors.textTertiary,
	// 	colors.mapWater,
	// 	colors.other
	// ].forEach((c) => {
	// 	colors.textColors[c] = getBrightness(c) < 180 ? colors.white : darken(c, 0.4)
	// })

	// colors.highlightColors = {}
	// ;[...colors.scaleMain, ...colors.scaleLarge, colors.gray].forEach((c) => {
	// 	colors.highlightColors[c] = getBrightness(c) < 200 ? c : darken(c, 0.4)
	// })

	colors.scaleDivergent = [
		colors.permits,
		colors.permitsSecondary,
		colors.construction,
		colors.add4,
		colors.permitsDark,
		colors.permitsSecondaryDark,
		colors.constructionDark,
		colors.add4Dark
	]
}

makeExtraColors()

export function getColors() {
	return colors
}

export function setColors(cs) {
	colors = { ...def }
	Object.keys(cs).forEach((k) => {
		if (cs[k]) colors[k] = cs[k]
	})
	makeExtraColors()
}
